<app-loader *ngIf="isLoading"></app-loader>
<ng-content *ngIf="store.getApplicationDto() | async"></ng-content>
